import { useEffect, useState } from 'react';
import * as React from 'react';
import {observer} from "mobx-react";
import styles from "./navigation/meganav/styles/megaNav.module.scss";
import classNames from 'classnames';
import {fetchState} from "../../stores/OrganizationStore";
import useDelayedFetchStates from "../../hooks/useDelayedFetchStates";

const scrollIndicatorClassName = classNames({
    [styles.apiProgressIndicator]: true,
});

const ApiProgressIndicator: React.FC<{}> = observer(() => {
    const [width, setWidth] = useState(0);

    const delayedFetchStates = useDelayedFetchStates();

    useEffect(() => {
        setWidth(1);

        let numPendingSchemaRequests = 0, numPendingResponseRequests = 0, numFinishedRequests = 0;

        const dfsArray = Object.values(delayedFetchStates);

        dfsArray.forEach(fs => {
            if (fs.value === fetchState['PENDING SCHEMA']) numPendingSchemaRequests++;
            else if (fs.value === fetchState['PENDING RESPONSE']) numPendingResponseRequests++;
            else if (fs.value === fetchState.SUCCESS || fs.value === fetchState.FAILURE) numFinishedRequests++;
        })

        // calculate current progress, assigning weights to each progress state
        const w = (numPendingSchemaRequests * .25) + (numPendingResponseRequests * .5) + numFinishedRequests / dfsArray.length;

        let t;
        setWidth(w);
        if (w === 1) {
            t = setTimeout(() => setWidth(0), 1000);
        }

        return () => clearTimeout(t);
    }, [JSON.stringify(delayedFetchStates)])

    return <div className={scrollIndicatorClassName} style={{width: (width * 100) + "%", opacity: width === 0 ? 0: 1}}/>
});

export default ApiProgressIndicator;
